<template>
    <template v-if="movement.driver">
        <p class="mb-0">
            Currently assigned to <a :href="generateDriverShowRoute()">{{ movement.driver.name }}</a>
            (
            {{ movement.transported ? 'Transported' : 'Driven' }}{{ movement.transported_to_suit ? ', Transported To Suit' : '' }}
                <span v-if="movement.status !== 'assigned'">
                    {{ movement.status }}
                </span>
            )
            <button class="btn btn-sm btn-success ms-2" @click="toggleTransportedOrDelivered()">
                Set {{ !movement.transported ? 'Transported' : 'Driven' }}
            </button>
            <button class="btn btn-sm text-white ms-2" :class="!movement.transported_to_suit ? 'bg-amethyst' : 'bg-amethyst-dark'" @click="toggleTransportedToSuit()">
                {{ !movement.transported_to_suit ? 'Set Transported To Suit' : 'Unset Transported To Suit' }}
            </button>
        </p>
    </template>
    <template v-else>
        <p class="mb-0">Unassigned</p>
    </template>
</template>

<script setup>
import { inject, watch } from 'vue';
import axios from 'axios';

const movement = defineModel();
const emit = defineEmits(['update:movement']);
const markLocalMovementMutation = inject('markLocalMovementMutation', null);

watch(movement, (newVal) => {
    emit('update:movement', newVal);
});

function generateDriverShowRoute() {
    return route('movements.drivers.show', movement.value.driver.id);
}

function toggleTransportedOrDelivered() {
    if (markLocalMovementMutation && movement.value?.id) {
        markLocalMovementMutation([movement.value.id]);
    }

    axios.post(route('api.movements.movements.toggle-transported', movement.value.id))
        .then(response => {
            movement.value.transported = response.data.transported;
        }).catch(error => {
            console.error('Error updating transported status:', error);
        });
}

function toggleTransportedToSuit() {
    if (markLocalMovementMutation && movement.value?.id) {
        markLocalMovementMutation([movement.value.id]);
    }

    // optimistic state change for better UX
    movement.value.transported_to_suit = !movement.value.transported_to_suit;

    axios.post(route('api.movements.movements.toggle-transported-to-suit', movement.value.id))
        .then(response => {
            movement.value.transported_to_suit = response.data.transported_to_suit;
        }).catch(error => {
        console.error('Error updating transported status:', error);
    });
}
</script>
